import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import MenuElementsList from 'components/Layout/_components/MenuElementsList/MenuElementsList';
import MenuSection from 'components/Layout/_components/MenuSection';
import checkAccess from 'config/permissions/checkAccess';
import compareWithRoutingPermissions from 'config/permissions/compareWithRoutingPermissions';
import menu_messages from 'messages/menu_messages';
import userDataStorage from 'storages/userDataStorage';

import menuElements from '../menuElements';

const PocketSafeAdministrationSection = () => {
  const { t } = useTranslation();
  // @ts-ignore
  const { ps_roles, roles, is_asset_owner, is_delegated } = userDataStorage.get() || {
    ps_roles: [],
    roles: [],
    is_asset_owner: false,
    is_delegated: false,
  };

  const elementsToDisplay = useMemo(() => {
    const userRoles = [...ps_roles, ...roles];

    const filtered = menuElements.pocketSafeAdmin.filter(element => {
      const hasRoleRestrictions = element.allowedForPSRoles?.length || element.allowedForOrganizationRoles?.length;
      let hasAccess = false;
      if (hasRoleRestrictions) {
        const allowedRoles = [...(element.allowedForOrganizationRoles || []), ...(element.allowedForPSRoles || [])];
        hasAccess = checkAccess(userRoles, allowedRoles);
      } else if (element.to) {
        hasAccess = compareWithRoutingPermissions(userRoles, element.to);
      } else {
        const allowedRoles = [...(element.allowedForOrganizationRoles || []), ...(element.allowedForPSRoles || [])];
        hasAccess = checkAccess(userRoles, allowedRoles);
      }
      if (!hasAccess) return false;
      if (element.requiresAssetOwner || element.requiresIsDelegated) {
        const hasFlag = (element.requiresAssetOwner && is_asset_owner) || (element.requiresIsDelegated && is_delegated);
        if (!hasFlag) return false;
      }
      return true;
    });

    // Sort alphabetically by translated label
    return filtered.sort((a, b) => {
      const labelA = t(a.label).toLowerCase();
      const labelB = t(b.label).toLowerCase();
      return labelA.localeCompare(labelB);
    });
  }, [ps_roles, roles, is_asset_owner, is_delegated, t]);

  if (!elementsToDisplay.length) return null;

  return (
    // @ts-ignore
    <MenuSection title={t(...menu_messages.ps_administrator)}>
      <MenuElementsList elements={elementsToDisplay} />
    </MenuSection>
  );
};

export default PocketSafeAdministrationSection;
